<script setup lang="ts">
// Production addition (P18-C04, not in the reference): a new app version is waiting. Never reloads by itself —
// the user chooses when; edits are already saved on the device, and the reload waits for any commit in progress.
import { ref } from 'vue';
import { applyUpdate, updateReady } from '@/pwa/register';
import { saveState } from '@/app/offlineWorkspace';
import { t } from '@/app/i18n';

const later = ref(false);
async function reload(): Promise<void> {
  for (let i = 0; i < 50 && saveState.value === 'saving'; i++) await new Promise(r => setTimeout(r, 100));
  applyUpdate();
}
</script>

<template>
  <div v-if="updateReady && !later" role="status" data-update-ready
    :style="s('position:absolute; left:50%; bottom:16px; transform:translateX(-50%); z-index:150; width:max-content; max-width:calc(100% - 32px); box-sizing:border-box; padding:8px 8px 8px 16px; border-radius:calc(12px * var(--tp-round, 1)); background:var(--ne7e7ea, #e7e7ea); color:var(--n1e1f22, #1e1f22); font-size:14px; box-shadow:0 12px 32px rgba(0,0,0,0.35); display:flex; align-items:center; gap:10px; animation:tpToast 200ms ease-out;')">
    <span :style="s('flex:1; min-width:0;')">{{ t('A new version is ready. Your changes are saved on this device.') }}</span>
    <button @click="reload" :style="s('height:30px; padding:0 14px; border:none; border-radius:calc(8px * var(--tp-round, 1)); background:var(--tp-accent, #5b8def); color:#16171a; font-family:inherit; font-size:13px; font-weight:700; cursor:pointer;')">{{ t('Reload') }}</button>
    <button :title="t('Later')" @click="later = true" :style="s('width:28px; height:28px; border:none; background:transparent; color:var(--n1e1f22, #1e1f22); opacity:0.6; font-size:16px; cursor:pointer;')">×</button>
  </div>
</template>
